// api
import { fetchApi } from '@/api'
// actions
const validateForm = (context, payload) => {
  let obj = JSON.parse(payload)
  console.log(obj)
  console.log(obj.typeEndPoint)
  let type = ''
  let url = ''
  if (obj.typeEndPoint === 'create') {
    type = 'POST'
    url = 'admin/users'
  } else if (obj.typeEndPoint === 'update') {
    type = 'PUT'
    url = 'admin/users/2'
  } else {
    context.commit('FORM', payload)
  }

  if (type !== '') {
    fetchApi(url, payload, type)
      .then((response) => {
        context.commit('FORM', payload)
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.error(error)
      })
  }
}

export default {
  validateForm
}



// WEBPACK FOOTER //
// ./src/store/modules/base/form/actions.js